<template>
    <div v-if="signingView" class="CerteuropeSignPages">
      <CerteuropeSignPage v-for="(page) in signingView.pages"
                          :key="`page-${page.number}`"
                          v-bind="$attrs"
                          class="my-2"
                          :selected-tag="selectedTag"
                          :mnemo="mnemo"
                          :page="page"
      />
      <v-row>
        <v-col class="text-center mt-2">
          <AppButton v-if="tagsCount === 0"
                     :disabled="signTagPending"
                     class="CerteuropeSignPages-finishButton"
                     :loading="confirmSignaturePending"
                     @click="onFinishClick"
          >
            {{ $t('common.finish') }}
          </AppButton>
        </v-col>
      </v-row>
    </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'

import { CerteuropeSignMutationTypes } from '@/store/modules/certeurope-sign/mutation_types'

import CerteuropeSignPage from './CerteuropeSignPage.vue'
import AppButton from '../common/buttons/AppButton.vue'

export default {
  name: 'CerteuropeSignPages',
  components: { AppButton, CerteuropeSignPage },
  props: {
    mnemo: {
      type: String,
      required: true,
    },
    selectedTag: {
      required: true,
    },
  },
  computed: {
    ...mapState('certeuropeSign', ['signingView', 'confirmSignaturePending', 'signTagPendingIds', 'unsignTagPendingIds']),
    tagsCount () {
      if (this.signingView && this.signingView.pages.length > 0) {
        let counter = 0
        this.signingView.pages.forEach(page => {
          counter += page.tags.filter(item => !item.isSigned && item.type !== 'optionalCheckbox').length
        })
        return counter
      }
      return null
    },
    signTagPending () {
      return this.signTagPendingIds.length > 0 || this.unsignTagPendingIds.length > 0
    },
  },
  methods: {
    ...mapMutations('certeuropeSign', [CerteuropeSignMutationTypes.SET_VALIDATION_MODAL_IS_OPEN]),
    onFinishClick () {
      if (this.signingView.signatureType === 'advanced') {
        this.$store.commit(`certeuropeSign/${CerteuropeSignMutationTypes.SET_VALIDATION_MODAL_IS_OPEN}`, true)
      } else if (this.signingView.signatureType === 'simple') {
        this.$emit('confirmSimpleSignature')
      }
    },
  },
}
</script>

<style scoped lang="scss">
  .CerteuropeSignPages-finishButton {
    animation: blink 1s infinite;
    background-color: rgb(var(--v-theme-primary));
    color: white;
  }
  @keyframes blink {
    0% {
      background-color: rgb(var(--v-theme-primary));
    }
    50% {
      background-color: #e7666a;
    }
    100% {
      background-color: rgb(var(--v-theme-primary));
    }
  }
</style>
